module.exports = __webpack_public_path__ + "img/petstairs44.d910c7f5.jpg";